import type { DashboardData, UserSummary } from "./subscriptionApi";

const PREFIX = "apitomcp:dashboard:v1:";

export function dashboardSummaryFromCache(email: string): UserSummary | null {
  const data = readDashboardCache(email);
  if (!data) return null;
  return {
    plan: data.plan,
    conversions_used_this_month: data.conversions_used_this_month,
    monthly_limit: data.monthly_limit,
    active_mcps: data.active_mcps,
    calls_today: data.calls_today,
    total_calls: data.total_calls,
  };
}

export function readDashboardCache(email: string): DashboardData | null {
  if (typeof window === "undefined") return null;
  const key = email.trim().toLowerCase();
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const data = JSON.parse(raw) as DashboardData;
    if (data.email?.toLowerCase() !== key) return null;
    return data;
  } catch {
    return null;
  }
}

export function writeDashboardCache(email: string, data: DashboardData): void {
  if (typeof window === "undefined") return;
  const key = email.trim().toLowerCase();
  if (!key) return;
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(data));
  } catch {
    /* quota or private mode */
  }
}
